import { COLORS, SIZE } from '@app/src/ui';
import styled from 'styled-components';

const ROOT = 'Home/listProducts/SectionOpportunity';


export const Allies = styled.div`
  background: ${COLORS.BLACK};
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  padding: 0 15px;
  display: none;

  img {
    height: 20px;
    &:not(:first-child) {
      margin-left: 40px;
    }
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    display: flex;
    img {
      height: 30px;
    }
  }
`;

Allies.displayName = `${ROOT}/Allies`;